import { DatePicker } from 'antd';
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import DetailPageHeader from 'components/header/DetailPageHeader';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import ListViewControlSelfAssurance from './ListViewControlSelfAssurance';
import useGetStateFromParams from 'static-solutions/hook/useGetStateFromParams';

const KpiComparativeConsole = () => {
	const [dataList, setDataList] = useState([]);
	const [selectedYear, setSelectedYear] = useState(null);

	const { state } = useGetStateFromParams();

	const [GetKpiComparative, { data: kpiComparativeData, isUninitialized, isLoading }] = useSendControlDataMutation();

	useEffect(() => {
		if (state?.processCode) {
			const payload = {
				year: selectedYear ? selectedYear : '',
			};

			const convertJson = JSON.stringify(payload);
			const convertBase64 = btoa(convertJson);

			GetKpiComparative({
				data: convertBase64,
				scriptName: 'kpi-by-functions',
				processCode: state?.processCode,
			});
		}
	}, [state.processCode, selectedYear]);

	useEffect(() => {
		if (kpiComparativeData?.responseData?.length > 0) {
			const data = kpiComparativeData?.responseData?.map((item) => {
				return {
					usersFound: item?.usersFound,
					functionName: item?.functionName,
					totalRawScore: item?.totalRawScore,
					userEvaluated: item?.userEvaluated,
					lowestRawScore: item?.lowestRawScore,
					averageRawScore: item?.averageRawScore,
					highestRawScore: item?.highestRawScore,
					functionMasterId: item?.functionMasterId,
					totalWeightedScore: item?.totalWeightedScore,
					lowestWeightedScore: item?.lowestWeightedScore,
					averageWeightedScore: item?.averageWeightedScore,
					highestWeightedScore: item?.highestWeightedScore,
				};
			});

			setDataList(data);
		} else {
			setDataList([]);
		}
	}, [kpiComparativeData]);

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<DetailPageHeader image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />} title={state?.processName ?? ''} />
				</Grid>

				<Grid item xs={12}>
					<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
						<Box sx={{ marginBottom: 2 }}>
							<label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Select Year</label>

							<DatePicker
								picker="year"
								style={{ width: 200 }}
								placeholder="Select Year"
								onChange={(value) => {
									setSelectedYear(value?.year());
								}}
							/>
						</Box>

						<ListViewControlSelfAssurance data={dataList} isLoading={isLoading && !isUninitialized} />
					</Box>
				</Grid>
			</Grid>
		</>
	);
};

export default KpiComparativeConsole;
